import { ContactCard, ThanksHeader } from "./message-report";
import Thanks from "../thanks.svg";
import Error from "../error.svg";
import { RoundGreyPlain } from "components/ui/Buttons/generic/GenericButton";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { post } from "services/config";
import { Link } from "react-router-dom";

const errorMessages: Record<string, any>= {
    "expired": {
        heading: "Ce lien est expiré.",
        message: <>Le lien sur lequel vous avez cliqué a expiré ou a déjà été utilisé. Notre équipe vous a déjà envoyé un nouveau lien pour mettre à jour votre disponibilité. Dans le cas où vous ne l'avez pas reçu, veuilez <Link to={"/contactez-nous"} className="text-primary-blue underline">contacter notre support client.</Link></>
    },
    "invalid": {
        heading: "Ce lien n'est pas valide.",
        message: <>Le lien que vous avez entré contient une référence qui n'est pas valide. Pour une réclamation quelconque n'hésitez pas à <Link to={"/contactez-nous"} className="text-primary-blue underline">contacter notre support client.</Link></>
    },
    "default": {
        heading: "Une erreur s'est produite.",
        message: <>Votre demande n'a pas pu être envoyée, nous vous prions de réessayer. Si le problème persiste, veuillez <Link to={"/contactez-nous"} className="text-primary-blue underline">contacter notre support client.</Link></>
    }
};

export default function SetAvailability() {
    const [isSent, setIsSent]= useState(false);

    const toggler= () => {
        setIsSent(true);
    };

    const [haveError, setHaveError]= useState(false);
    const [errorContent, setErrorContent]= useState<string|null>(null);
    const makeError= (content?: string) => {//Sorry for the name :D
        setHaveError(true);
        setErrorContent(content||null);
    };

    return<>
    <div className="md:h-[100vh] w-full flex flex-col gap-0 items-stretch">
        <ThanksHeader/>
        {
            haveError ?
            <ErrorBody content={errorContent||undefined}/>
            :
                isSent ?
                <ThanksBody/>
                :
                <SendingBody toggler={toggler} makeError={makeError}/>
        }
    </div>
    </>;
};


const ThanksBody= () => {
    return(<>
        <div className="flex flex-col items-center flex-[1] lg:gap-[89px] gap-[40px] justify-center bg-[#f4f4f5] w-full lg:p-0 md:p-0 md:py-[100px] py-[117px]">
            <div className="flex flex-col gap-[30px] md:max-w-[672px] max-w-[90vw] w-full">
                <img src={Thanks} alt="PHONE" className="w-[60px]"/>
                <h1 className="text-[30px] leading-[36px] font-semibold text-[#1d1d39]">Wall of Share vous remercie.</h1>
                <p className="text-[20px] leading-[24px] font-normal text-[#6f6f6f]">Votre disponibilité a bien été mise à jour.</p>
                <RoundGreyPlain text={"Retourner sur le site"} to={"/"} className="px-[27px] py-[13.5px] font-semibold text-[18px] leading-[23.44px]" isButton={false}/>
            </div>
            <ContactCard />
        </div>
    </>);
};

const ErrorBody= ({content}: {content?: string}) => {
    return(<>
        <div className="flex flex-col items-center flex-[1] lg:gap-[89px] gap-[40px] justify-center bg-[#f4f4f5] w-full lg:p-0 md:p-0 md:py-[100px] py-[117px]">
            <div className="flex flex-col gap-[30px] md:max-w-[672px] max-w-[90vw] w-full">
                <img src={Error} alt="PHONE" className="w-[60px]"/>
                <h1 className="text-[30px] leading-[36px] font-semibold text-[#1d1d39]">{errorMessages[content||"default"].heading}</h1>
                <p className="text-[20px] leading-[24px] font-normal text-[#6f6f6f]">{errorMessages[content||"default"].message}</p>
                <RoundGreyPlain text={"Retourner sur le site"} to={"/"} className="px-[27px] py-[13.5px] font-semibold text-[18px] leading-[23.44px]" isButton={false}/>
            </div>
            <ContactCard />
        </div>
    </>);
};

const SendingBody= ({toggler, makeError}: {toggler: ()=> void, makeError: (a?: string)=> void}) => {

    const [searchParams, _]= useSearchParams();
    const history= useNavigate();
    const ref= searchParams.get('ref');
    
    useEffect(()=> {
        console.log(ref);
        if (ref=== null){
            history('/');
            return;
        }
        post('/api/confirmation-de-disponibilite', {ref: ref}).then(response => {
            if ((response.status === 200) && (response.data)) {
                const data: any = response.data;
                console.log(response.data);
                switch(data.result.message.toLowerCase()){
                    case "ok": {
                        toggler();
                        break;
                    }
                    case "invalid": {
                        makeError("invalid");
                        break;
                    }
                    case "expired": {
                        makeError("expired");
                        console.log("expired");
                        break;
                    }
                    default: {
                        makeError();
                        break;
                    }
                }
            } else {
                //Error
                makeError();
            }
        }).catch(error => {
            console.log(error);
            makeError();
        });
    }, []);

    return(<>
        <div className="flex flex-col items-center flex-[1] lg:gap-[89px] gap-[40px] justify-center bg-[#f4f4f5] w-full lg:p-0 md:p-0 md:py-[100px] py-[117px]">
            <div className="flex flex-col gap-[30px] md:max-w-[672px] max-w-[90vw] w-full">
                <h1 className="text-[30px] leading-[36px] font-semibold text-[#1d1d39] text-center">Mise à jour de votre disponibilité...</h1>
                <div className="w-full flex items-center justify-center">
                    <WosLoadingIndicator/>
                </div>
            </div>
            <ContactCard />
        </div>
    </>);
}

export const WosLoadingIndicator= ({big= true}: {big?: boolean}) =>  {
    return<div className={"wos-loading- " + `${!big ? 'small' : ''}`}></div>;
};